// extracted by mini-css-extract-plugin
export default {"wrapper":"Nav_wrapper__SBfng","item":"Nav_item__v7vEo","bounce":"Nav_bounce__Rtyp4","heart-icon":"Nav_heart-icon__O1Nzw"};